import React, {useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {FiShield} from 'react-icons/fi';
import {verifyOtp} from '../../api/api';
import AuthFlowLayout from './AuthFlowLayout';

export default function OtpScreen() {
  const navigate = useNavigate();
  const {state} = useLocation();
  const email = state?.email || '';
  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerify = async e => {
    e.preventDefault();
    const cleanOtp = otp.trim();
    if (!email) return setMessage('Please request a password reset first.');
    if (!/^\d{6}$/.test(cleanOtp)) return setMessage('Please enter the 6 digit OTP.');
    try {
      setLoading(true); setMessage('');
      await verifyOtp({email, otp: cleanOtp});
      navigate('/reset-password', {state: {email, otp: cleanOtp}});
    } catch (err) {
      setMessage(err.response?.data?.message || err.message || 'OTP verification failed.');
    } finally { setLoading(false); }
  };

  return (
    <AuthFlowLayout eyebrow="Account recovery" heroTitle="Check your inbox" heroText="Use the six-digit verification code we sent to continue securely." icon={<FiShield />} benefitTitle="Protected verification" benefitText="The code confirms that this account belongs to you." formEyebrow="Verification" title="Enter your OTP" subtitle={<>We sent a code to <strong>{email || 'your email address'}</strong>.</>}>
      <form onSubmit={handleVerify} className="auth-flow-form">
        <label className="auth-flow-label" htmlFor="otp">6-digit code</label>
        <input id="otp" className="auth-flow-input auth-flow-input--otp" type="text" inputMode="numeric" autoComplete="one-time-code" maxLength={6} placeholder="000000" value={otp} onChange={e => setOtp(e.target.value.replace(/\D/g, ''))} autoFocus />
        {message && <p className="auth-flow-message" role="alert">{message}</p>}
        <button className="auth-flow-submit" type="submit" disabled={loading}>{loading ? 'Verifying...' : 'Verify code'}</button>
      </form>
      <button className="auth-flow-back" type="button" onClick={() => navigate('/forgot-password')}>Back to Forgot Password</button>
    </AuthFlowLayout>
  );
}
